import useUser from '@/utils/hooks/useUser'
import type { HTMLAttributes } from 'react'
import { useInView } from 'react-intersection-observer'
import Avatar from './Avatar'
import FollowToggleButton from './FollowToggleButton'
import ScreenName from './ScreenName'
import styles from './UserList.module.css'

export interface UserListProps extends HTMLAttributes<HTMLDivElement> {
	/**
	 * username list
	 */
	data: string[]
	onLoadMore: () => void
}

export default function UserList({ data, onLoadMore, ...props }: UserListProps) {
	const { ref: loadMoreRef } = useInView({
		onChange: (inView) => {
			if (inView) {
				// loadmore
				onLoadMore?.()
			}
		},
	})

	return (
		<div {...props}>
			<div className={styles.list}>
				{data.map((username) => (
					<UserListItem key={username} username={username} />
				))}
			</div>
			<div ref={loadMoreRef} className={styles.loadMoreRef} />
		</div>
	)
}

function UserListItem({ username }: { username: string }) {
	const data = useUser(username)

	if (!data) {
		return null
	}

	return (
		<div className={styles.item}>
			<div className={styles.itemContent}>
				<Avatar data={data} className={styles.itemAvatar} />
				<div className={styles.itemInfo}>
					<ScreenName data={data} />
					<div className={styles.itemBio}>{data.briefIntro}</div>
				</div>
			</div>

			<FollowToggleButton data={data} size="sm" noAddIcon className={styles.followButton} />
		</div>
	)
}
